import _slicedToArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";

/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */
import * as map from './map.js';
import * as string from './string.js';
import * as conditions from './conditions.js';
import * as storage from './storage.js';
import * as f from './function.js';
/* c8 ignore next */
// @ts-ignore

export var isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* c8 ignore next */

export var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && !isNode;
/* c8 ignore next 3 */

export var isMac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */

var params;
var args = [];
/* c8 ignore start */

var computeParams = function computeParams() {
  if (params === undefined) {
    if (isNode) {
      params = map.create();
      var pargs = process.argv;
      var currParamName = null;

      for (var i = 0; i < pargs.length; i++) {
        var parg = pargs[i];

        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }

          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          } else {
            args.push(parg);
          }
        }
      }

      if (currParamName !== null) {
        params.set(currParamName, '');
      } // in ReactNative for example this would not be true (unless connected to the Remote Debugger)

    } else if (typeof location === 'object') {
      params = map.create(); // eslint-disable-next-line no-undef

      (location.search || '?').slice(1).split('&').forEach(function (kv) {
        if (kv.length !== 0) {
          var _kv$split = kv.split('='),
              _kv$split2 = _slicedToArray(_kv$split, 2),
              key = _kv$split2[0],
              value = _kv$split2[1];

          params.set("--".concat(string.fromCamelCase(key, '-')), value);
          params.set("-".concat(string.fromCamelCase(key, '-')), value);
        }
      });
    } else {
      params = map.create();
    }
  }

  return params;
};
/* c8 ignore stop */

/**
 * @param {string} name
 * @return {boolean}
 */

/* c8 ignore next */


export var hasParam = function hasParam(name) {
  return computeParams().has(name);
};
/**
 * @param {string} name
 * @param {string} defaultVal
 * @return {string}
 */

/* c8 ignore next 2 */

export var getParam = function getParam(name, defaultVal) {
  return computeParams().get(name) || defaultVal;
};
/**
 * @param {string} name
 * @return {string|null}
 */

/* c8 ignore next 4 */

export var getVariable = function getVariable(name) {
  return isNode ? conditions.undefinedToNull(process.env[name.toUpperCase()]) : conditions.undefinedToNull(storage.varStorage.getItem(name));
};
/**
 * @param {string} name
 * @return {string|null}
 */

/* c8 ignore next 2 */

export var getConf = function getConf(name) {
  return computeParams().get('--' + name) || getVariable(name);
};
/**
 * @param {string} name
 * @return {boolean}
 */

/* c8 ignore next 2 */

export var hasConf = function hasConf(name) {
  return hasParam('--' + name) || getVariable(name) !== null;
};
/* c8 ignore next */

export var production = hasConf('production');
/* c8 ignore next 2 */

var forceColor = isNode && f.isOneOf(process.env.FORCE_COLOR, ['true', '1', '2']);
/* c8 ignore start */

export var supportsColor = !hasParam('no-colors') && (!isNode || process.stdout.isTTY || forceColor) && (!isNode || hasParam('color') || forceColor || getVariable('COLORTERM') !== null || (getVariable('TERM') || '').includes('color'));
/* c8 ignore stop */